export default __webpack_public_path__ + "static/media/167399319_118106233697232_6971585097702603053_n.863eacc2.jpg";